<template>
  <div v-if="state.list.length > 0">
    <div class="text-base md:text-xl font-bold mb-4">Interactive DAPP</div>

    <div class="flex">
      <DappChart v-if="isDesktop" />
      <DappRanks v-if="isDesktop" />
      <CustomCarousel
        v-if="!isDesktop"
        :contents="[
          { component: DappChart },
          {
            component: DappRanks,
          },
        ]"
      />
      <!-- <DappChart :list="state.list" />
      <DappRanks :list="state.list" /> -->
      <!-- <div class="flex flex-col flex-1 min-w-0 mr-6">
        <div>
          <div class="flex space-x-4">
            <div
              class="bar-item-btn font-bold"
              :class="{
                'bar-item-btn__active': state.timeType == i,
              }"
              v-for="(item, i) in ['1Y', 'All']"
              :key="i"
              @click="state.timeType = i"
              style="min-width: auto; font-size: 12px"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="flex-1 min-h-0">
          <VChart class="chart" :option="option"></VChart>
        </div>
      </div> -->

      <!-- <div
        class="bg-white-005 rounded px-2 py-4 space-y-3"
        style="width: 180px"
      >
        <div class="flex items-center px-2" v-for="(item, i) in ranks" :key="i">
          <SortTag
            :sortValue="i + 1"
            style="width: 16px; height: 16px; font-size: 12px"
          ></SortTag>

          <div class="ml-2 flex justify-between flex-1 min-w-0 text-xs">
            <div>{{ item[0] }}</div>
            <div>{{ item[1] }}</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script setup>
import { queryOvDaoInterData } from '@/api/dao';
import SortTag from '@/components/SortTag.vue';

import { useDesktop, useReqByBool } from '@/hooks';

import { computed, inject, onMounted, reactive } from 'vue';

import DappChart from './DappChart.vue';
import DappRanks from './DappRanks.vue';
import CustomCarousel from '@/components/CustomCarousel.vue';

const daoPageInfo = inject('daoPageInfo');
const isDesktop = useDesktop();
const state = reactive({
  list: [],
});

const { loadData, loading } = useReqByBool(async () => {
  try {
    const res = await queryOvDaoInterData(daoPageInfo.vueState.info.id);
    state.list = res;
  } catch (error) {
    console.log(error);
  }
});

onMounted(() => {
  loadData();
});
</script>

<style lang="scss" scoped></style>
